import { render, staticRenderFns } from "./sbrfq-add-or-update.vue?vue&type=template&id=ccbcc5c2&scoped=true"
import script from "./sbrfq-add-or-update.vue?vue&type=script&lang=js"
export * from "./sbrfq-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./sbrfq-add-or-update.vue?vue&type=style&index=0&id=ccbcc5c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbcc5c2",
  null
  
)

export default component.exports